/**
 * Fix scroll drawer Monster Cart su iOS Safari/Chrome.
 *
 * Monster Cart apre il drawer applicando solo `body { overflow: hidden }` inline.
 * Su iOS Safari questo non blocca lo scroll del document, e quando l'utente swipa
 * in un'area "morta" del drawer (overlay laterale, header, footer) iOS associa la
 * gesture al document scroller invece che al container interno della lista.
 *
 * Soluzione: osserva l'inline style del body; quando arriva `overflow: hidden`,
 * applichiamo il body-lock pattern (position: fixed + top:-scrollY) che funziona
 * su iOS, e settiamo touch-action / overscroll-behavior sui nodi del drawer per
 * impedire scroll chaining.
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var LOCK_ATTR = 'data-faan-mu-locked';
  var body = document.body;
  var savedScrollY = 0;
  var observer;

  function findScrollContainer(wrapper) {
    var nodes = wrapper.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cs = getComputedStyle(el);
      if ((cs.overflowY === 'auto' || cs.overflowY === 'scroll') &&
          el.scrollHeight > el.clientHeight + 1) {
        return el;
      }
    }
    return null;
  }

  function applyDrawerTouchProps() {
    var wrapper = document.getElementById('monster-cart-wrapper');
    if (!wrapper) return;

    wrapper.style.overscrollBehavior = 'contain';

    var overlay = document.querySelector('[class*="monster_upsell_overlay"]');
    if (overlay) {
      overlay.style.touchAction = 'none';
      overlay.style.overscrollBehavior = 'contain';
    }

    var scroller = findScrollContainer(wrapper);
    if (scroller) {
      scroller.style.touchAction = 'pan-y';
      scroller.style.overscrollBehavior = 'contain';
      scroller.style.webkitOverflowScrolling = 'touch';
    }
  }

  function lockBody() {
    if (body.hasAttribute(LOCK_ATTR)) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    observer.disconnect();
    body.setAttribute(LOCK_ATTR, '1');
    body.style.position = 'fixed';
    body.style.top = '-' + savedScrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    document.documentElement.style.overflow = 'hidden';
    observer.observe(body, { attributes: true, attributeFilter: ['style'] });
    requestAnimationFrame(applyDrawerTouchProps);
    setTimeout(applyDrawerTouchProps, 200);
  }

  function unlockBody() {
    if (!body.hasAttribute(LOCK_ATTR)) return;
    observer.disconnect();
    body.removeAttribute(LOCK_ATTR);
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    observer.observe(body, { attributes: true, attributeFilter: ['style'] });
    document.documentElement.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  function isMonsterLocked() {
    return /overflow\s*:\s*hidden/i.test(body.getAttribute('style') || '');
  }

  observer = new MutationObserver(function () {
    if (isMonsterLocked()) {
      lockBody();
    } else {
      unlockBody();
    }
  });

  observer.observe(body, { attributes: true, attributeFilter: ['style'] });

  if (isMonsterLocked()) lockBody();

  window.addEventListener('beforeunload', function () {
    observer.disconnect();
  });
})();
